//*********************************
// slick-carousel
//*********************************

console.log('slick-carousel');

import $ from 'jquery';
import slick from 'slick-carousel';

//slick-responsive
var $optsResponsive = {
	dots: true,
	arrows: false,
	infinite: true,
	slidesToShow: 3,
	slidesToScroll: 3,
	autoplay: true,
	autoplaySpeed: 10000,
 pauseOnFocus: false,
 pauseOnHover: true,
	responsive: [
   {
    breakpoint: 1599,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
   {
    breakpoint: 1439,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
 {
    breakpoint: 1199,
    settings: {
      slidesToShow: 3,
      slidesToScroll: 3
    }
  },
 {
    breakpoint: 1023,
    settings: {
      slidesToShow: 2,
      slidesToScroll: 2
    }
  },
  {
    breakpoint: 639,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1
    }
  }
 ]
}

// callback before slide change
$('.slick-carousel .slick-responsive').on('beforeChange', function(event, slick, currentSlide, nextSlide){
 //console.log('before ' + nextSlide);

});

// callback after slide change
$('.slick-carousel .slick-responsive').on('afterChange', function(event, slick, currentSlide, nextSlide){
 //console.log('after ' + currentSlide);
});

$('.slick-carousel .slick-responsive').slick($optsResponsive);

//slick-single-slide
var $optsSlide = {
  dots: true,
  arrows: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  pauseOnFocus: false,
  pauseOnHover: true,
  pauseOnDotsHover: false
}
$('.slick-carousel .slick-single-slide').not('.slick-initialized').slick($optsSlide);

//slick-single-fade
var $optsFade = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  fade: true,
  cssEase: 'linear',
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 6000,
  pauseOnFocus: false,
  pauseOnHover: true,
  pauseOnDotsHover: false
}
$('.slick-carousel .slick-single-fade').not('.slick-initialized').slick($optsFade);
